import { PaymentSlugs } from '@/modules/Leads/constants/Routing';

// Check if the path is a payment-related path (used by allowUnpaidAppAuthTokens middleware)
export const isAnUnpaidAppPath = (path: string = ''): boolean =>
  Object.values(PaymentSlugs).some((wl) => path.includes(wl));

export default null;
